<div class="icon-nav">
  <ul>
    <li class="onhover-div mobile-search search-widgets" id="search-widgets">
      <div (click)="searchToggle()">
        <img src="assets/images/icon/search.png" class="img-fluid icon-nav__img" alt="">
        <i class="ti-search"></i>
      </div>
      <div
        id="search-overlay"
        #searchOverlay
        class="search-overlay"
        [ngStyle]="{'display': search ? 'block' : 'none'}">
        <div class="search-overlay__inner">
          <span class="closebtn" (click)="searchToggle()">×</span>
          <div class="overlay-content">
            <div class="container">
              <div class="row">
                <div class="col-xl-12">
                  <form (ngSubmit)="onSearchSubmit($event)">
                    <div class="col-sm-12 empty-cart-cls text-center">
                      <img src="assets/images/empty-compare.png" class="img-fluid mb-4" >
                      <h3><strong>¡Explora más, busca los mejores productos!</strong></h3>
                      <br>
                  </div>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="searchTerm"
                        [(ngModel)]="searchTerm"
                        placeholder="Buscar productos, marcas y más..."
                        (input)="onSearchInput($event)"
                      />
                    </div>
                  </form>
                </div>
                <div class="col-12 search-overlay__actions mt-4">
                  <button type="submit" class="btn-solid search-overlay__submit" (click)="onSearchSubmit($event)">
                    Buscar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
    <li class="onhover-div mobile-shuffle">
      <div>
        <a [routerLink]="['/shop/compare']">
          <i class="ti-control-shuffle"></i>
        </a>
      </div>
    </li>
    <li class="onhover-div mobile-cart">
      <div>
        <a [routerLink]="['/shop/cart']">
          <img src="assets/images/icon/cart.png" class="img-fluid icon-nav__img" alt="">
          <i class="ti-shopping-cart"></i>
        </a>
        <span class="cart_qty_cls">{{ getCantTotal | async }}</span>
      </div>
      <div class="cont-signin" *ngIf="!products.length">
        <ul class="show-div shopping-cart mega-cart-empty-panel mt-3">
          <li>
            <p class="mega-cart-empty-msg">Tu carrito está vacío</p>
          </li>
        </ul>
      </div>
      <ul class="show-div shopping-cart" *ngIf="products.length">
        <li *ngFor="let product of products">
          <div class="media">
            <a [routerLink]="product | productDetailLink" [queryParams]="product | productDetailQueryParams">
              <img class="me-3" [src]="product?.images[0].src" [alt]="product?.images[0].alt">
            </a>
            <div class="media-body">
              <a [routerLink]="product | productDetailLink" [queryParams]="product | productDetailQueryParams">
                <h4 class="mega-cart-item-title">{{ product?.title }}</h4>
              </a>
              <h4>
                <span>
                  {{ product?.quantity }} x
                  {{ product?.price * productService?.Currency.price | discount:product | currency:productService?.Currency.currency:'symbol' }}
                </span>
              </h4>
            </div>
          </div>
          <div class="close-circle" (click)="removeItem(product)">
            <a href="javascript:void(0)"><i class="fa fa-times" aria-hidden="true"></i></a>
          </div>
        </li>
        <li>
          <div class="total">
            <h5>subtotal : <span>{{ getTotal | async | currency:productService?.Currency.currency:'symbol' }}</span></h5>
          </div>
        </li>
        <li>
          <div class="buttons">
            <a [routerLink]="['/shop/cart']" class="view-cart">Ver Carrito</a>
            <a href="javascript:void(0)" class="checkout" (click)="goToCheckout($event)">checkout</a>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</div>
